import {useWeb3React } from "@web3-react/core"
import { useState, useEffect } from 'react'
import {Stack, Center, Spinner} from '@chakra-ui/react';
import { getMeta } from '../lib/nftList'
import NFTCard from './nftcard'

const List = (props) => {
    const { account } = useWeb3React()
    let [nfts, setNFTs] = useState([])
    let [loading, setLoading] = useState(true)

    const click = (meta) => {
        props.onClick(meta)
    }

    useEffect(()=>{
        getMeta().then(meta=>{
            let nftCards = meta.map(data=><NFTCard key={data.name} {...data} onClick={click}/>)
            setNFTs(nftCards)
            setLoading(false)
        })
    },[])

    return (
       <div style={{width: 800, textAlign: 'center', marginTop: 20, marginBottom: 50}}>
          {loading && 
            <Spinner size='lg' style={{marginTop: 200}}/>
          }
          {!loading &&
            nfts
          }
          
       </div>
    )
}

export default List